import { Button as RadixButton } from '@radix-ui/themes';
import { withMappingProps } from '../../utils/radix.js';
export const Button = withMappingProps(RadixButton);
//# sourceMappingURL=button.js.map